import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Grid,
  Card,
} from "@mui/material";
import { toast } from "react-toastify";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { getDatabase, ref, get, remove } from "firebase/database";
import TutorialDialogBox from "../../DialogBox/TutorialDialogBox";

const Tutorial = () => {
  const [allData, setAllData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedTutorial, setSelectedTutorial] = useState({});
  const navigate = useNavigate();

  const getData = () => {
    const db = getDatabase();
    const dbRef = ref(db, "tutorial");
    get(dbRef).then((snapshot) => {
      if (snapshot.exists()) {
        const data = Object.entries(snapshot.val()).map(([key, value]) => ({
          id: key,
          ...value,
        }));
        setAllData(data);
      } else {
        setAllData([]);
      }
    });
  };

  const openModal = () => {
    setSelectedTutorial({});
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
    getData();
  };

  const deleteTutorial = (tutorial) => {
    const db = getDatabase();
    const dbRef = ref(db, `/tutorial/${tutorial.id}`);

    remove(dbRef)
      .then(() => {
        toast.info("Tutorial removed!", {
          autoClose: 3000,
          position: toast.POSITION.TOP_CENTER,
        });
        getData();
      })
      .catch((error) => console.error("Error deleting:", error));
  };

  const edit = (tutorial) => {
    setSelectedTutorial(tutorial);
    setOpen(true);
  };

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) navigate("/authentication/sign-in");
    getData();
  }, []);

  return (
    <DashboardLayout>
      {open && <TutorialDialogBox open={open} onClose={close} tutorial={selectedTutorial} />}

      <MDBox pt={12} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <MDTypography
                  variant="h6"
                  color="white"
                  sx={{ fontWeight: "bold", fontSize: "1.5rem" }}
                >
                  YOUTUBE TUTORIAL DASHBOARD
                </MDTypography>
              </MDBox>

              <button
                className="btn btn-success mt-2 ms-3 mb-3"
                style={{ width: 200 }}
                onClick={openModal}
              >
                ADD TUTORIAL
              </button>

              <MDBox>
                <TableContainer component={Paper}>
                  <Table sx={{ "& td, & th": { fontSize: "14px", padding: "8px" } }}>
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Title
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Link
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableBody>

                    {allData.map((tut) => (
                      <TableRow key={tut.id}>
                        <TableCell align="center">{tut.title}</TableCell>
                        <TableCell align="center">{tut.link}</TableCell>

                        <TableCell align="center">
                          <button
                            className="btn btn-success ms-4 mb-2"
                            style={{ width: 120 }}
                            onClick={() => edit(tut)}
                          >
                            Edit
                          </button>
                          <button
                            className="btn btn-danger ms-4 mb-2"
                            style={{ width: 120 }}
                            onClick={() => deleteTutorial(tut)}
                          >
                            Delete
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                  </Table>
                </TableContainer>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
};

export default React.memo(Tutorial);
